export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/ebay.7ff749b.svg";